const moduleNameKey = "dashboardTileGrid";

export const dashboardTileGridEn = {
  [moduleNameKey]: {
    editWidget: "Edit widget",
    duplicateWidget: "Duplicate widget",
    deleteWidget: "Delete widget",
  },
};

export const dashboardTileGridPtBr = {
  [moduleNameKey]: {
    editWidget: "Editar widget",
    duplicateWidget: "Duplicar widget",
    deleteWidget: "Excluir widget",
  },
};

export const dashboardTileGridDe = {
  [moduleNameKey]: {
    editWidget: "Widget bearbeiten",
    duplicateWidget: "Widget duplizieren",
    deleteWidget: "Widget löschen",
  },
};

export const dashboardTileGridZhHans = {
  [moduleNameKey]: {
    editWidget: "编辑小部件",
    duplicateWidget: "复制小部件",
    deleteWidget: "删除小部件",
  },
};

export const dashboardTileGridIt = {
  [moduleNameKey]: {
    editWidget: "Modifica widget",
    duplicateWidget: "Duplica widget",
    deleteWidget: "Elimina widget",
  },
};

export const dashboardTileGridEs = {
  [moduleNameKey]: {
    editWidget: "Editar widget",
    duplicateWidget: "Duplicar widget",
    deleteWidget: "Eliminar widget",
  },
};

export const dashboardTileGridNl = {
  [moduleNameKey]: {
    editWidget: "Widget bewerken",
    duplicateWidget: "Widget dupliceren",
    deleteWidget: "Widget verwijderen",
  },
};

export const dashboardTileGridTr = {
  [moduleNameKey]: {
    deleteWidget: "Widget'ı sil",
    duplicateWidget: "Widget'ı kopyala",
    editWidget: "Widget'ı düzenle",
  },
};
